import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { BottomContent, BtnRow, ButtonAdd, ChoiceItem, Content, ContentGrid, PickType, Tag, Tags, TextArea, TitleLeft } from './SickDetails.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import SickLessons from './SickLessons';
import SickPeriod from './SickPeriod';
import CrossIcon from '@assets/svg/match/missing.svg';
import UpcomingSick from './UpcomingSick';
import { useAuthentication } from '@providers/AuthProvider';
import Cross_Icon from "@assets/svg/match/missing.svg";
import { BoxTop, Popup, PopupBox } from '@components/Redeem/Redeembackup.styled';

interface IProps { }

export const SickDetails = (props: IProps) => {
  const i18n = useI18n();
  const { client, selectedSchoolViewSearch, whoIsLoggedIn, settings, schoolViewTags } = useStore();
  const [open, setOpen] = useState(false)
  const openRef = useRef(null)
  const [tags, setTags] = useState(null)
  const [selectedTags, setSelectedTags] = useState([])
  const [sickType, setSickType] = useState(true)
  const [text, setText] = useState('')
  const [selectedLectures, setSelectedLectures] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [selectedToDate, setSelectedToDate] = useState()
  const { getId } = useAuthentication();
  const [sickEvents, setSickEvents] = useState(null)
  const [show, setShow] = useState(false)
  const popupText = useRef(null)
  const popupHeaderText = useRef(null)
  const [edit, setEdit] = useState(null)
  const [creatingevent, setCreatingEvent] = useState(false)

  useEffect(() => {
    getSickEvents()
  }, [])

  const ConvertTags = (list: any) => {
    if (list === null || list.length < 0) return []

    let ids = list.split(',')
    let tags = []
    for (let i = 0; i < ids.length; i++) {
      let tempTag = schoolViewTags.find(t => t.tag_id == ids[i])
      if (tempTag) {
        tags.push(tempTag)
      }
    }

    return tags
  }

  const getSickEvents = async () => {
    let events = await db.getSickEvent4Student(selectedSchoolViewSearch.id, 0)
    let absenceIds = [...new Set(events?.map((item) => item.absence_id))]
    let temp = []
    for (let i = 0; i < absenceIds.length; i++) {
      let tempAbsences = events.filter(a => a.absence_id === absenceIds[i])
      let dates = tempAbsences.map(a => new Date(a.date))
      let fromDate = moment(Math.min(...dates)).format("DD MMMM YYYY")
      let toDate = moment(Math.max(...dates)).format("DD MMMM YYYY")
      let dateText = fromDate
      if (toDate !== fromDate) dateText = fromDate + " - " + toDate
      let days = {}

      let t = []
      for (let y = 0; y < tempAbsences.length; y++) {
        if (tempAbsences[y].starttime && tempAbsences[y].endtime && tempAbsences[y].displayname && tempAbsences[y].coursedescription) {
          let starttime = tempAbsences[y].starttime?.hours.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          }) + ":" + tempAbsences[y].starttime?.minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })
          let endtime = tempAbsences[y].endtime?.hours.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          }) + ":" + tempAbsences[y].endtime?.minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })

          if (!days[tempAbsences[y].date]) days[tempAbsences[y].date] = []

          days[tempAbsences[y].date].push({ displayname: tempAbsences[y].displayname + " " + tempAbsences[y].coursedescription, starttime: starttime, endtime: endtime, date: tempAbsences[y].date, reservationId: tempAbsences[y].reservation_id })
          t.push({ displayname: tempAbsences[y].displayname + " " + tempAbsences[y].coursedescription, starttime: starttime, endtime: endtime, date: tempAbsences[y].date, reservationId: tempAbsences[y].reservation_id })
        }
      }

      temp.push({ absenceId: tempAbsences[0].absence_id, date: dateText, text: tempAbsences[0].text, timeblocks: t, tags: ConvertTags(tempAbsences[0].tag_ids), days: days })
    }


    setSickEvents(temp)
  }

  const handleTagClick = (tagId) => {
    let sTags = JSON.parse(JSON.stringify(selectedTags))
    if (sTags.includes(tagId)) sTags = sTags.filter(s => s !== tagId)
    else sTags.push(tagId)
    setSelectedTags(sTags)
  }

  const handleInput = (e) => {
    setText(e.target.value)
  }

  const selectLectures = (lectures, all) => {
    let s = JSON.parse(JSON.stringify(selectedLectures))
    if (all) {
      if (selectedLectures.length > 0) setSelectedLectures([])
      else setSelectedLectures(lectures)
    }
    else {
      if (selectedLectures.includes(lectures)) s = s.filter(s => s !== lectures)
      else s.push(lectures)
      setSelectedLectures(s)
    }
  }

  const handleDate = (type, date) => {
    setSelectedDate(date)
  }

  const createEvent = async (text, tags) => {
    setCreatingEvent(true)
    if(edit)await db.deleteSickEvent4Student(edit)
    let json = null
    let authorId = getId();
    if (sickType === true) {
      json = selectedLectures?.map(s => {
        return { reservationId: s }
      })
    }
    else {
      let date = moment(selectedDate)
      let fromDate = moment(selectedDate)
      let toDate = moment(selectedToDate)
      let courses = []
      while (date.isSameOrAfter(fromDate, 'date') && date.isSameOrBefore(toDate, 'date')) {
        let c = await db.Regi_GetCoursesByStudentName(selectedSchoolViewSearch?.username, date, settings.USEMERIT, settings.USEPAUSE)
        courses = courses.concat(c)
        date = date.add(1, 'days')
      }
      json = courses?.map(s => {
        return { reservationId: s.id }
      })
    }

    let tagsToString = tags.length > 0 ? tags.join(",") : "empty";

    let result = await db.createLeaveEvent(selectedSchoolViewSearch?.id, selectedSchoolViewSearch?.username, authorId === null ? 'empty' : authorId, client.UserName, `${whoIsLoggedIn.firstname} ${whoIsLoggedIn.lastname}`, json, text, tagsToString, 2, 1)
    if (result && result.length > 0 && result[0].absence_id > 0) {
      popupText.current = "absence-created"
      popupHeaderText.current = 'confirm'
      setSelectedTags([])
      setText('')
      setSelectedLectures([])
      getSickEvents()
      setShow(true)
    }
    else {
      popupHeaderText.current = 'oops'
      popupText.current = "absence-exist"
      setShow(true)
    }
    
    setEdit(null)
    CancelEdit()
    setCreatingEvent(false)
  }

  const editSickEvent = (event) => {
    if (Object.keys(event.days).length > 1) {
      let fromDate = null
      let toDate = null
      let dates = Object.keys(event.days).map(d => new Date(d))
      fromDate = dates.reduce(function (a, b) { return a < b ? a : b; });
      toDate = dates.reduce(function (a, b) { return a > b ? a : b; });
      setSelectedDate(fromDate)
      setSelectedToDate(toDate)
      setSelectedLectures([])
      setSickType(false)
      setText(event.text)
      setSelectedTags(event.tags.map(t => t.tag_id))
      setEdit(event.absenceId)
    }
    else {
      setSelectedTags(event.tags.map(t => t.tag_id))
      setSelectedLectures(event.timeblocks.map(t => t.reservationId))
      for (const [key, value] of Object.entries(event.days)) {
        let date = moment(key)
        setSelectedDate(date.toDate())
      }
      setText(event.text)
      setEdit(event.absenceId)
      setSickType(true)
    }
  }

  const CancelEdit = () => {
    setSelectedDate(new Date())
    setSelectedToDate(null)
    setSelectedLectures([])
    setSickType(true)
    setText("")
    setSelectedTags([])
    setEdit(null)
  }

  return (<>
    <Popup show={show}>
      <PopupBox>
        <BoxTop>
          <span>{i18n.t(popupHeaderText.current)}</span>
          <button onClick={() => setShow(false)}>
            <Cross_Icon />
          </button>
        </BoxTop>
        <span></span>
        <p>{i18n.t(popupText.current)}</p>
        <div>
          <button onClick={() => { setShow(false); popupText.current = null; }}>{i18n.t("ok")}</button>
        </div>
      </PopupBox>
    </Popup>
    <ContentGrid>
      <Content>
        <TitleLeft>
          {i18n.t("report-sick-create")}
        </TitleLeft>

        <PickType>
          <ChoiceItem onClick={() => setSickType(true)} selected={sickType === true}><div />{i18n.t("report-sick-lessons")}</ChoiceItem>
          <ChoiceItem onClick={() => setSickType(false)} selected={sickType === false}><div />{i18n.t("report-sick-peried")}</ChoiceItem>
        </PickType>

        {sickType ? <SickLessons selectDate={handleDate} selectedDate={selectedDate} selectLectures={selectLectures} selectedLectures={selectedLectures} studentId={selectedSchoolViewSearch?.id} studentUsername={selectedSchoolViewSearch?.username} /> : <SickPeriod selectedToDate={selectedToDate} selectToDate={setSelectedToDate} selectFromDate={handleDate} selectedFromDate={selectedDate} />}


        <Tags>
          {schoolViewTags?.map(t => { return !selectedTags.includes(t.tag_id) ? <Tag key={t.tag_id} display={false} onClick={() => handleTagClick(t.tag_id)} c={false} bgColor={t.html_color}>{i18n.t("tag-" + t.name)}</Tag> : <></> }
          )}

        </Tags>
        <BottomContent>
          <TextArea>

            <textarea value={text} onChange={handleInput} placeholder={i18n.t("note-placeholder")} />
            <Tags>
              {selectedTags.map(st => {
                let tag = schoolViewTags.find(t => t.tag_id === st)
                if (tag)
                  return <Tag key={tag.tag_id} display={false} onClick={() => handleTagClick(tag.tag_id)} c={false} bgColor={tag.html_color}>{i18n.t("tag-" + tag.name)}<div><CrossIcon /></div></Tag>
                else return <></>
              })}

            </Tags>
          </TextArea>
          <BtnRow>
            <ButtonAdd onClick={() => createEvent(text.trim(), selectedTags)} disabled={text.trim().length === 0 && selectedTags.length === 0 || creatingevent}>{edit ? i18n.t("update") : i18n.t("schoolview-holiday-popup-create")}</ButtonAdd>
            {edit?<ButtonAdd onClick={() => CancelEdit()}>{i18n.t("cancel")}</ButtonAdd>:null}
          </BtnRow>
        </BottomContent>
      </Content>

      <Content>
        <TitleLeft>
          {i18n.t("report-sick-upcoming")}
        </TitleLeft>

        <UpcomingSick editSickEvent={editSickEvent} sickEvents={sickEvents} studentId={selectedSchoolViewSearch?.id} updateSickEvents={getSickEvents} />
      </Content>
    </ContentGrid>
  </>);
};

export default SickDetails;
